import { Dialog } from '@mui/material';
import AppSpacer from './AppSpacer';
import AppDialogHeader from './AppDiaglogHeader';

export const AppDialog = ({
  title,
  isOpened,
  onClose,
  children,
  classNames = '',
  maxWidth = 'md',
  stickyHeader = false,
  customHeader
}: {
  title: string;
  onClose: () => void;
  isOpened: boolean;
  children: React.ReactNode;
  classNames?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  stickyHeader?: boolean;
  customHeader?: React.ReactElement<typeof AppDialogHeader>;
}) => {
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth
      className={`app-dialog ${classNames}`}
      open={isOpened}
      onClose={onClose}
      data-test='service-dialog'
    >
      <div className='d-flex flex-column h-100'>
        {customHeader ?? <AppDialogHeader title={title} stickyHeader={stickyHeader} />}
        <AppSpacer space='24px' />
        {children}
      </div>
    </Dialog>
  );
};

export default AppDialog;
